import { defineComponent, h } from 'vue';
import { isAiTemplateEnabled } from '@/ui/helpers/featureHelper';
import OldChecklistChooseTemplatePage from '@/ui/pages/checklist/checklistChooseTemplatePage/OldChecklistChooseTemplatePage.vue';
import NewChecklistChooseTemplatePage from '@/ui/pages/checklist/checklistChooseTemplatePage/NewChecklistChooseTemplatePage.vue';

export const ChecklistChooseTemplatePage = defineComponent({
  name: 'ChecklistChooseTemplatePage',
  setup() {
    return function render() {
      return isAiTemplateEnabled() ? h(NewChecklistChooseTemplatePage) : h(OldChecklistChooseTemplatePage);
    };
  },
});
